import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropertyOverview from '@componentsV2/PropertyOverview';
import {
  sGetDocuments,
  sGetFetchingDocuments,
} from '@/store/reducers/documents';
import PropertyDocumentsEntry from '@componentsV2/PropertyDocumentsEntry';
import ValueEstimateOverview from '@componentsV2/ValueEstimateOverview';
import { getPropertyOwnerSubscriptionStatus } from '@/utils/properties';
import { sGetUnitFeatures } from '@/store/reducers/unitFeatures';
import { sGetUser } from '@/store/reducers/auth';
import EnergyMark from '@componentsV2/EnergyMark';
import { updateProperty } from '@/api/properties';
import { propertyUpdateAction } from '@/store/actions/properties';
// import PropertyCompanies from '@componentsV2/PropertyCompanies';
import { getDashboardLinkPrefix } from '@/utils/routes';
import VendorsGrid from '@componentsV2/VendorsGrid';
import { getCompaniesByIds } from '@/api/searchApi';
import PropertyCompanies from '@componentsV2/PropertyCompanies';
import { acSetDocumentSearchText } from '../../../../store/actions/documents';
import { ErrorMessage } from './ErrorMessage';
import { getUserTransactions } from '../../../../api/boligmappaPlus';
import { acSetUserTransactions } from '../../../../store/actions/userTransactions';
import {
  sGetActiveProperty,
  sGetDocumentsToSigned,
  sGetPropertyCompanyStats,
  sGetPropertyValueEstimates,
  sGetPropertyValueIncreases,
} from '../../../../store/reducers/properties';

export const Home = ({
  authUser,
  activeProperty,
  propertyCompanyStats,
  propertyDocuments,
  fetchingDocuments,
  propertyValueIncreases,
  propertyValueEstimates,
  unitFeatures,
  fetchingProperties,
  fetchingPropertiesError,
  setSearchText,
  setUserTransactions,
  setUpdatedProperty,
}) => {
  const [companies, setCompanies] = useState([]);
  const [fetchingCompanies, setFetchingCompanies] = useState(true);
  const boligmappaPlusSubscriptionStatus =
    getPropertyOwnerSubscriptionStatus(authUser);

  useEffect(() => {
    setSearchText('');
  }, []);

  const fetchUserTransactions = async () => {
    const [error, response] = await getUserTransactions();
    if (!error && response) {
      setUserTransactions(response.responses);
    }
  };

  const fetchCompanies = async (ids) => {
    setFetchingCompanies(true);
    const [error, response] = await getCompaniesByIds(ids);
    // const [error, response] = await getCompaniesByIds(['4430', '197', '17868']);

    if (!error && response) {
      setCompanies(response);
    }
    setFetchingCompanies(false);
  };

  const onPropertyDataChange = async (data) => {
    const [error] = await updateProperty(activeProperty.boligmappaNumber, data);
    return !error;
  };

  useEffect(() => {
    fetchUserTransactions();
  }, []);

  useEffect(() => {
    if (activeProperty?.boligmappaNumber && propertyCompanyStats?.length > 0) {
      fetchCompanies(
        propertyCompanyStats.find(
          (el) => el.boligmappaNumber === activeProperty.boligmappaNumber
        ).companyIds
      );
    }
  }, [activeProperty, propertyCompanyStats]);

  if (fetchingPropertiesError) {
    return <ErrorMessage fetchingPropertiesError={fetchingPropertiesError} />;
  }

  return (
    <>
      <div className="px-[15px] py-8 md:py-10">
        <div className="flex flex-col max-w-screen-md mx-auto font-circular gap-9 md:gap-14">
          <PropertyOverview
            property={activeProperty}
            setUpdatedProperty={setUpdatedProperty}
            onPropertySpaceChange={onPropertyDataChange}
            fetching={fetchingProperties}
          />
          <PropertyDocumentsEntry
            property={activeProperty}
            propertyDocuments={propertyDocuments}
            fetching={fetchingDocuments}
          />
          <ValueEstimateOverview
            isBlurred={!boligmappaPlusSubscriptionStatus}
            allProperties={activeProperty?.id && [activeProperty]}
            valueIncreases={
              propertyValueIncreases && [
                ...propertyValueIncreases.ownedPropertyPriceHistories,
                ...propertyValueIncreases.sharedPropertyPriceHistories,
              ]
            }
            valueEstimates={
              propertyValueEstimates && [
                ...propertyValueEstimates.ownedPropertyValueEstimate,
                ...propertyValueEstimates.sharedPropertyValueEstimate,
              ]
            }
          />
          <EnergyMark
            activeProperty={activeProperty}
            unitFeatures={unitFeatures?.unitFeatures}
            createdTime={unitFeatures?.unitFeatures?.certificateIssueDate}
            defaultEnergyScore={
              activeProperty?.customPropertyFacts?.energyScore
            }
            defaultHeatingScore={
              activeProperty?.customPropertyFacts?.heatingScore
            }
            isCustomFacts={
              !!activeProperty?.customPropertyFacts?.energyScore?.value
            }
            onEnergyDataChange={onPropertyDataChange}
          />
          {!fetchingCompanies && (
            <PropertyCompanies
              companies={companies}
              dashboardLinkPrefix={getDashboardLinkPrefix(
                activeProperty?.boligmappaNumber
              )}
            />
          )}
          <VendorsGrid
            dashboardLinkPrefix={getDashboardLinkPrefix(
              activeProperty?.boligmappaNumber
            )}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  authUser: sGetUser(state),
  propertyDocuments: sGetDocuments(state),
  fetchingDocuments: sGetFetchingDocuments(state),
  propertyValueIncreases: sGetPropertyValueIncreases(state),
  propertyValueEstimates: sGetPropertyValueEstimates(state),
  documentsToSigned: sGetDocumentsToSigned(state),
  activeProperty: sGetActiveProperty(state),
  propertyCompanyStats: sGetPropertyCompanyStats(state),
  unitFeatures: sGetUnitFeatures(state),
});

const mapDispatchToProps = (dispatch) => ({
  setSearchText: (searchText) => dispatch(acSetDocumentSearchText(searchText)),
  setUserTransactions: (userTransactions) =>
    dispatch(acSetUserTransactions(userTransactions)),
  setUpdatedProperty: (property) => dispatch(propertyUpdateAction(property)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
